import { FC } from 'react';
import { EArticleClass, IGalleryArticleDetail, IVideoArticleDetail } from 'shared/models';
import { ScopedProvider, useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { EArticleGalleryLayoutStrategy } from '~/components/article-gallery/atoms';
import { PostDetailModalAtoms } from './atoms';
import {
  ArticleComments,
  ArticleInfoBar,
  ArticleRelatedPost,
  ArticleRelatedTopic,
  AuthorBar,
  VideoPlayer,
} from './components';
import { ArticleGallery } from '../article-gallery';
import { PostDetailVideoPlayer } from './components/video-player/atom';
import { WapArticleSection } from './components/wap-article';
import { ClickPositionPrefix } from '~/utils/click-position';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';
import { CampaignCarousel } from '../campaign-carousel';
import { PlaceholderFooter } from './components/placeholder-footer';

export const PostDetailModal: FC = () => {
  const articleRelatedPost = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticleRelatedPost);
  const currentArticle = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticle);

  const { articleClass } = currentArticle;

  const renderCommonSection = (): JSX.Element => {
    return (
      <>
        <ArticleInfoBar />
        <WapArticleSection />
        <ArticleComments />
        <ArticleRelatedPost />
        <ArticleRelatedTopic />
        <CampaignCarousel />
        <PlaceholderFooter />
      </>
    );
  };

  if (articleClass === EArticleClass.GALLERY) {
    return (
      <div className="post-detail-modal">
        <ScopedProvider
          atoms={[PostDetailModalAtoms.$CurrentArticleFold, PostDetailModalAtoms.$CurrentArticleHeightComputed]}
          atomsWithHydration={[
            [PostDetailModalAtoms.$CurrentGalleryArticle, currentArticle as IGalleryArticleDetail],
            [$CurrentPositionPrefix, ClickPositionPrefix.experience],
          ]}
        >
          <AuthorBar />
          <ArticleGallery
            article={currentArticle as IGalleryArticleDetail}
            layoutStrategy={EArticleGalleryLayoutStrategy.RECTANGLE}
            enableIndexForRecommend={true}
            articleRelatedPosts={articleRelatedPost}
            positionPrefix={ClickPositionPrefix.experience}
          />
          {renderCommonSection()}
        </ScopedProvider>
      </div>
    );
  } else {
    return (
      <div className="post-detail-modal">
        <ScopedProvider
          atoms={[
            PostDetailVideoPlayer.$EndRecommendShow,
            PostDetailVideoPlayer.$ReplayVideo,
            PostDetailModalAtoms.$CurrentArticleFold,
            PostDetailModalAtoms.$CurrentArticleHeightComputed,
          ]}
          atomsWithHydration={[
            [PostDetailModalAtoms.$CurrentVideoArticle, currentArticle as IVideoArticleDetail],
            [$CurrentPositionPrefix, ClickPositionPrefix.experience],
          ]}
        >
          <AuthorBar />
          <VideoPlayer />
          {renderCommonSection()}
        </ScopedProvider>
      </div>
    );
  }
};
